import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "../../framework/helpers/BreakpointHelper/BreakpointHelper";

export const HeroType = styled.div.attrs({
    id: "hero",
})`
    margin: 0 auto;
    display: flex;
`;

export const HeroTypeWrapper = styled.div.attrs(
    ({imageFromRight, theme, useMargin}) => ({
        id: "HeroTypeWrapper",
        imageFromRight, useMargin
    })
)`
    display: flex;
    flex: 1;
    flex-direction: ${({imageFromRight}) => imageFromRight ? "row-reverse" : "row"};
    gap: 2rem;

    > div {
        flex: 1;
        flex-basis: 50%;
    }

    & {
        ${media.lessThan(breakpoints.ipadPlus)`
		min-height: 46vh;
		align-items:stretch;
		flex-direction: column;
		gap: 1rem;

  `}
        ${media.greaterThan(breakpoints.ipadPlus)`
		  min-height: 482px;
		  align-items: center;
		  margin-top: ${({theme, useMargin}) => useMargin ? theme?.block?.gap ? theme?.block?.gap : "0" : "0"};
		  margin-bottom: ${({useMargin}) => useMargin ? "0" : "2rem"};
    `}
    }
}
`;

export const HeroTypeTextWrapper = styled.div.attrs(
    ({horizontalPosition}) => ({
        id: "HeroTypeTextWrapper",
        contnetHorizontalPosition: horizontalPosition ? horizontalPosition : 'flex-start'
    })
)`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 1rem;
    padding: 1.5rem 1rem;
    align-items: ${({contnetHorizontalPosition}) => contnetHorizontalPosition};

    & {
        ${media.greaterThan(breakpoints.ipadPlus)`		    
            padding: 5rem 4.5rem;
		    gap: 2rem;
    `}

    }
`;

export const HeroTypeButtonWrapper = styled.div.attrs(
    ({}) => ({
        id: "HeroTypeButtonWrapper"
    })
)`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    flex-wrap: wrap;
}
`;


